import React from "react";

function MenuItem({ label, icon, active, onClick }) {
  return (
    <li
      className={`flex items-center cursor-pointer px-4  md:px-3.5 py-1.5 md:h-[80%]  justify-center font-semibold tracking-wide whitespace-nowrap rounded-[41px] ${
        active ? "text-[#AF313D]  bg-orange-50" : "text-white"
      } ${active ? "md:gap-2 gap-1 sm:gap-1" : "gap-1 sm:gap-0.5"} sm:px-2 sm:py-1`}
      onClick={onClick}
    >
      <img
        loading="lazy"
        src={icon}
        alt={label}
        className={`object-contain shrink-0 ${
          active ? "" : "filter brightness-0 invert"
        } ${
          active ? "lg:w-12 sm:w-6 w-4" : "lg:w-12 sm:w-5 w-3.5"
        } aspect-square`}
      />
      <span
        className={`body ${
          active
            ? "lg:text-[20px] md:text-[14px] sm:text-[10px] text-[9px]"
            : "lg:text-[16px] md:text-[12px] sm:text-[8px] text-[8px]"
        }`}
      >
        {label}
      </span>
    </li>
  );
}

export default MenuItem;
